'use client';

import Image from '@/components/Image';

interface Banner4Data {
  banner_image: string;
  title: string;
  banner_image2: string;
  sub_title1: string;
  sub_content1: string;
  banner_image3: string;
  sub_title2: string;
  sub_content2: string;
  banner_image4: string;
  sub_title3: string;
  sub_content3: string;
}

interface BottomBannerMobileProps {
  banner4: Banner4Data;
}

export default function BottomBannerMobile({ banner4 }: BottomBannerMobileProps) {
  if (!banner4) {
    return null;
  }

  return (
    <div className="bg-[#0f0f0f] pt-[42px] pb-[10px] flex flex-col items-center">
      <Image
        src={banner4.banner_image}
        alt="Zeelool optical eyeglasses online store8"
        width={248}
        height={200}
        className="w-[247.5px]"
      />
      <h5
        className="w-[255px] font-bb text-center mt-[32px] mb-[40px] text-[40px] text-white leading-[35px]"
        dangerouslySetInnerHTML={{ __html: banner4.title }}
      />

      <Image
        src={banner4.banner_image2}
        alt="Zeelool optical eyeglasses online store9"
        width={256}
        height={200}
        className="w-[256px] h-auto mb-[26px]"
      />
      <p className="mb-[18px] text-[35px] leading-[30px] text-white font-bb px-[14px]">
        {banner4.sub_title1}
      </p>
      <p className="text-[#a6a6a6] text-[14px] leading-[23px] w-[314.5px] pb-[40.5px]">
        {banner4.sub_content1}
      </p>

      <Image
        src={banner4.banner_image3}
        alt="Zeelool optical eyeglasses online store10"
        width={256}
        height={200}
        className="w-[256px] h-auto mb-[26px]"
      />
      <p className="mb-[18px] text-[35px] leading-[30px] text-white font-bb px-[14px]">
        {banner4.sub_title2}
      </p>
      <p className="text-[#a6a6a6] text-[14px] leading-[23px] w-[314.5px] pb-[40.5px]">
        {banner4.sub_content2}
      </p>

      <Image
        src={banner4.banner_image4}
        alt="Zeelool optical eyeglasses online store11"
        width={256}
        height={200}
        className="w-[256px] h-auto mb-[26px]"
      />
      <p className="mb-[18px] text-[35px] leading-[30px] text-white font-bb px-[14px]">
        {banner4.sub_title3}
      </p>
      <p className="text-[#a6a6a6] text-[14px] leading-[23px] w-[314.5px] pb-[40.5px]">
        {banner4.sub_content3}
      </p>
    </div>
  );
}
